import rem from 'polished/lib/helpers/rem';

function pxInRem(pxSize: string | number) {
  return rem(pxSize, '14px');
}

export default pxInRem;
